<template>
      <div class="ruleCertificationCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'ruleCertification', params: {} }">
          Rule Certification
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'ruleCertificationCreate', params: {} }">
            Create Rule Certification
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Rule Certification</v-card-title>
          <v-card-text>
            <ruleCertification-form></ruleCertification-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import RuleCertificationForm from './RuleCertificationForm.vue';

    export default {
      name: 'ruleCertification',
      components: {
        RuleCertificationForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    